var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescQuadroFnbSpaces(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 645.024,
    height: 946,
    viewBox: "0 0 645.024 946",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_8736",
    x: 18.5,
    y: 0,
    width: 626.525,
    height: 946,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#989898",
    floodOpacity: 0.404
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "app_bar",
    x: 121.5,
    y: 152.254,
    width: 416.525,
    height: 95.254,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "app_bar-2",
    x: 121.5,
    y: 102,
    width: 416.525,
    height: 95.254,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-fnb"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "vectorMask",
    cx: 16.153,
    cy: 16.153,
    r: 16.153,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base_bianca",
    x: 137.858,
    y: 322.171,
    width: 387.808,
    height: 504,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base1",
    x: 152.217,
    y: 336.53,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base9",
    x: 152.217,
    y: 494.473,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base17",
    x: 152.217,
    y: 652.416,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base5",
    x: 152.217,
    y: 415.501,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base13",
    x: 152.217,
    y: 573.444,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base2",
    x: 235.675,
    y: 336.53,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base10",
    x: 235.675,
    y: 494.473,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base18",
    x: 235.675,
    y: 652.416,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base6",
    x: 235.675,
    y: 415.501,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base14",
    x: 235.675,
    y: 573.444,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base3",
    x: 318.236,
    y: 336.53,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base11",
    x: 318.236,
    y: 494.473,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base19",
    x: 318.236,
    y: 652.416,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base7",
    x: 318.236,
    y: 415.501,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base15",
    x: 318.236,
    y: 573.444,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base4",
    x: 401.695,
    y: 336.53,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-20"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base12",
    x: 401.695,
    y: 494.473,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-21"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-21"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base20",
    x: 401.695,
    y: 652.416,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-22"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-22"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base8",
    x: 401.695,
    y: 415.501,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-23"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-23"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base16",
    x: 401.695,
    y: 573.444,
    width: 109.613,
    height: 109.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-24"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-24"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base21",
    x: 152.217,
    y: 731.387,
    width: 109.613,
    height: 94.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-25"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-25"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base22",
    x: 235.676,
    y: 731.387,
    width: 109.613,
    height: 94.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-26"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-26"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base23",
    x: 318.236,
    y: 731.387,
    width: 109.613,
    height: 94.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-27"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-27"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base24",
    x: 401.695,
    y: 731.387,
    width: 109.613,
    height: 94.613,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-28"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-28"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Base",
    x: 336.184,
    y: 271.02,
    width: 240.634,
    height: 240.634,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-29"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-29"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fnb_table",
    transform: "translate(-232 -4138.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M85.651-430.137a42.482,42.482,0,0,1,42.5,42.464v205.249a42.482,42.482,0,0,1-42.5,42.464h-42.5V-387.673A42.482,42.482,0,0,1,85.651-430.137Z",
    transform: "translate(92.04 4705.849) rotate(90)",
    fill: "#d42f51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_4",
    "data-name": "Intersection 4",
    d: "M75.279,125.638H51.038a1.5,1.5,0,0,1,0-3H75.279a1.5,1.5,0,0,1,0,3Zm17.716-6.316H33.322a1.5,1.5,0,1,1,0-3H92.994a1.5,1.5,0,0,1,0,3Zm9.564-6.316h-78.8a1.5,1.5,0,1,1,0-3h78.8a1.5,1.5,0,0,1,0,3Zm6.814-6.316H16.944a1.5,1.5,0,1,1,0-3h92.429a1.5,1.5,0,1,1,0,3Zm5.031-6.124H11.913a1.5,1.5,0,0,1,0-3H114.4a1.5,1.5,0,0,1,0,3Zm3.816-5.963H8.1a1.5,1.5,0,1,1,0-3H118.219a1.5,1.5,0,0,1,0,3ZM121.28,88.4H5.036a1.5,1.5,0,0,1,0-3H121.28a1.5,1.5,0,0,1,0,3Zm2.269-6.207H2.767a1.5,1.5,0,0,1,0-3H123.549a1.5,1.5,0,1,1,0,3Zm1.562-6.207H1.205a1.5,1.5,0,1,1,0-3H125.111a1.5,1.5,0,0,1,0,3ZM126,69.776H.294a1.5,1.5,0,0,1,0-3H126a1.5,1.5,0,0,1,0,3Zm0-6.207H0a1.5,1.5,0,0,1,0-3H126a1.5,1.5,0,0,1,0,3Zm0-6.207H.308a1.5,1.5,0,0,1,0-3H126a1.5,1.5,0,0,1,0,3Zm-.918-6.207H1.234a1.5,1.5,0,1,1,0-3H125.082a1.5,1.5,0,0,1,0,3ZM123.5,44.949H2.812a1.5,1.5,0,0,1,0-3H123.5a1.5,1.5,0,0,1,0,3Zm-2.286-6.207H5.1a1.5,1.5,0,0,1,0-3H121.218a1.5,1.5,0,0,1,0,3Zm-3.081-6.207H8.179a1.5,1.5,0,0,1,0-3H118.137a1.5,1.5,0,0,1,0,3ZM114.3,26.571H12.019a1.5,1.5,0,0,1,0-3H114.3a1.5,1.5,0,0,1,0,3Zm-5.062-6.124H17.08a1.5,1.5,0,0,1,0-3h92.155a1.5,1.5,0,1,1,0,3Zm-6.861-6.316H23.941a1.5,1.5,0,0,1,0-3h78.433a1.5,1.5,0,0,1,0,3ZM92.721,7.816H33.6a1.5,1.5,0,0,1,0-3H92.721a1.5,1.5,0,0,1,0,3ZM74.5,1.5H51.815a1.5,1.5,0,0,1-1.5-1.5,1.5,1.5,0,0,1,1.5-1.5H74.5A1.5,1.5,0,0,1,76,0,1.5,1.5,0,0,1,74.5,1.5Z",
    transform: "translate(715 4586)",
    fill: "#434f57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52237",
    "data-name": "Group 52237",
    transform: "translate(134 -81)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 98, 4219.5)",
    filter: "url(#Rectangle_8736)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8736-2",
    "data-name": "Rectangle 8736",
    width: 371.525,
    height: 691,
    transform: "translate(144 122.5)",
    fill: "#f4f4fd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Breadcrumb_Bar",
    "data-name": "Breadcrumb Bar",
    transform: "translate(242 4392.254)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -144, -172.75)",
    filter: "url(#app_bar)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "app_bar-3",
    "data-name": "app_bar",
    d: "M371.525,0H0V50.255H371.525Z",
    transform: "translate(144 172.75)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Spaces",
    transform: "translate(14.358 29.153)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Spaces"))), /*#__PURE__*/React.createElement("g", {
    id: "AppBar",
    transform: "translate(242 4342)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -144, -122.5)",
    filter: "url(#app_bar-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "app_bar-4",
    "data-name": "app_bar",
    d: "M371.525,0H0V50.255H371.525Z",
    transform: "translate(144 122.5)",
    fill: "#fefefe",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "header_profilo",
    "data-name": "header profilo",
    transform: "translate(288.066 8.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icona_notifiche",
    "data-name": "icona notifiche",
    d: "M4713.565,186.324c0-2.826-1.473-5.191-4.039-5.817v-.626a1.347,1.347,0,1,0-2.692,0v.626c-2.575.626-4.038,2.982-4.038,5.817v4.6L4701,192.766v.921h14.358v-.921l-1.794-1.841Zm-5.385,10.125a1.513,1.513,0,0,0,.358-.037,1.833,1.833,0,0,0,1.293-1.086,1.9,1.9,0,0,0,.134-.718h-3.589A1.831,1.831,0,0,0,4708.18,196.448Z",
    transform: "translate(-4699.206 -171.321)",
    fill: "#9299a8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "avatar_icon",
    "data-name": "avatar icon",
    transform: "translate(36.794)",
    clipPath: "url(#clip-path-fnb)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avatar_icon-2",
    "data-name": "avatar icon"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 32.306,
    height: 32.306,
    xlinkHref: "data:image/jpeg;base64,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"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_603",
    "data-name": "Ellipse 603",
    cx: 2.244,
    cy: 2.244,
    r: 2.244,
    transform: "translate(0 2.692)",
    fill: "#cb2d24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(14.358 10.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-2",
    "data-name": "menu",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_menu"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "base-2",
    "data-name": "base",
    width: 28.717,
    height: 28.717,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_menu-2",
    "data-name": "ic_menu",
    transform: "translate(6 7.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_menu-3",
    "data-name": "ic_menu",
    d: "M.76,14A.847.847,0,0,1,0,13.087a.847.847,0,0,1,.76-.913h15.2a.847.847,0,0,1,.76.913.847.847,0,0,1-.76.913Zm0-6.087A.847.847,0,0,1,0,7a.847.847,0,0,1,.76-.913h15.2a.847.847,0,0,1,.76.913.847.847,0,0,1-.76.913Zm0-6.087A.847.847,0,0,1,0,.913.847.847,0,0,1,.76,0h15.2a.847.847,0,0,1,.76.913.847.847,0,0,1-.76.913Z",
    fill: "#9299a8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52237-2",
    "data-name": "Group 52237",
    transform: "translate(57.434 14.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M149.39-405.813v21.538h21.539v-21.538Zm18.9,18.925h-4.379v-.958H152.961v-14.4h14.4v10.975h.927Z",
    transform: "translate(-149.39 405.813)",
    fill: "#b74857"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(7.546 7.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33330",
    "data-name": "Path 33330",
    d: "M158.87-399.116c-.042-.008-.085-.011-.128-.016a.578.578,0,0,0,.018-.14c0-.255-.155-.462-.346-.462s-.346.207-.346.462a.626.626,0,0,0,.018.138c-.042.006-.085.01-.126.016a2.645,2.645,0,0,0-2.189,2.383h5.288A2.643,2.643,0,0,0,158.87-399.116Zm-2.251,1.564a2.034,2.034,0,0,0-.169.467.115.115,0,0,1-.138.086.115.115,0,0,1-.087-.137,2.228,2.228,0,0,1,.19-.521.113.113,0,0,1,.156-.044.114.114,0,0,1,.048.15Zm1.407-1.029a1.959,1.959,0,0,0-1.128.624.116.116,0,0,1-.162.015.116.116,0,0,1-.015-.162l.006-.008a2.19,2.19,0,0,1,1.261-.7.111.111,0,0,1,.11.038.115.115,0,0,1-.013.162.123.123,0,0,1-.058.027Z",
    transform: "translate(-155.298 399.734)",
    fill: "#b74857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33331",
    "data-name": "Path 33331",
    d: "M160.21-395.257a.455.455,0,0,1-.081-.257v-.865a.117.117,0,0,0-.117-.115h1.154a.115.115,0,0,0,.115-.115.232.232,0,0,1,.231-.231.115.115,0,0,0,.115-.115v-.115a.116.116,0,0,0-.115-.115h-6a.116.116,0,0,0-.115.115v.115a.114.114,0,0,0,.115.115h0a.233.233,0,0,1,.231.231.114.114,0,0,0,.115.115h1.153a.118.118,0,0,0-.115.117.121.121,0,0,0,.034.081L159-394.223Zm-2.855-1.238h2.425a.576.576,0,0,0-.554.411l-.2.665-1.181-.909A.811.811,0,0,0,157.355-396.494Z",
    transform: "translate(-155.398 400.417)",
    fill: "#b74857"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42584-2",
    "data-name": "Group 42584-2",
    transform: "translate(3.577 5.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33332",
    "data-name": "Path 33332",
    d: "M160.51-395.182l-.477-.512a.115.115,0,0,0-.16-.009l-1.615,1.384a.12.12,0,0,0-.041.084.122.122,0,0,0,.034.086l.132.132A3.732,3.732,0,0,0,160.51-395.182Z",
    transform: "translate(-158.218 395.731)",
    fill: "#b74857"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Sale",
    transform: "translate(256.358 4510.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Billing",
    transform: "translate(181.275 -3.899)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Sala_3",
    "data-name": "Sala 3",
    transform: "translate(16 23)",
    fill: "#3a4750",
    fontSize: 13,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sala 3"))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(90.638 -3.899)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Sala_2",
    "data-name": "Sala 2",
    transform: "translate(16 23)",
    fill: "#3a4750",
    fontSize: 13,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sala 2"))), /*#__PURE__*/React.createElement("g", {
    id: "Details",
    transform: "translate(0 -1.899)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 68,
    height: 32,
    rx: 4,
    fill: "#b54756"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Sala_1",
    "data-name": "Sala 1",
    transform: "translate(52 21)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.169,
    y: 0
  }, "Sala 1"))))), /*#__PURE__*/React.createElement("g", {
    id: "reservation_button",
    transform: "translate(256.358 4464.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_25-2",
    "data-name": "Rectangle 25",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#3a4750",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.073,
    height: 32.306,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 112.073,
    height: 31.306,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41763",
    "data-name": "Group 41763",
    transform: "translate(14.358 8.077)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Reservations",
    transform: "translate(82 13)",
    fill: "#3a4750",
    fontSize: 14,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -82.038,
    y: 0
  }, "Reservations")))), /*#__PURE__*/React.createElement("g", {
    id: "tables_button",
    transform: "translate(383.79 4464.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_25-3",
    "data-name": "Rectangle 25",
    transform: "translate(0 0)",
    fill: "#b54756",
    stroke: "#b74857",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.895,
    height: 32.306,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69.895,
    height: 31.306,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41763-2",
    "data-name": "Group 41763",
    transform: "translate(14.358 8.077)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Tables",
    transform: "translate(41 13)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -41.166,
    y: 0
  }, "Tables")))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 98, 4219.5)",
    filter: "url(#Base_bianca)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base_bianca-2",
    "data-name": "Base_bianca",
    width: 342.808,
    height: 459,
    transform: "translate(158.36 339.67)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(270.717 4573.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -172.72, -354.03)",
    filter: "url(#Base1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base1-2",
    "data-name": "Base1",
    width: 64.613,
    height: 64.613,
    transform: "translate(172.72 354.03)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#009060"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52050",
    "data-name": "Group 52050",
    transform: "translate(26.025 19.743)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1-2",
    "data-name": 1,
    transform: "translate(6 20)",
    fill: "#474243",
    fontSize: 22,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.311,
    y: 0
  }, "1")))), /*#__PURE__*/React.createElement("g", {
    id: "_9",
    "data-name": 9,
    transform: "translate(270.717 4731.473)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -172.72, -511.97)",
    filter: "url(#Base9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base9-2",
    "data-name": "Base9",
    width: 64.613,
    height: 64.613,
    transform: "translate(172.72 511.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-2",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#009060"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52050-2",
    "data-name": "Group 52050",
    transform: "translate(26.025 19.743)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_9-2",
    "data-name": 9,
    transform: "translate(6 20)",
    fill: "#474243",
    fontSize: 22,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.311,
    y: 0
  }, "9")))), /*#__PURE__*/React.createElement("g", {
    id: "_17",
    "data-name": 17,
    transform: "translate(270.717 4889.416)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -172.72, -669.92)",
    filter: "url(#Base17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base17-2",
    "data-name": "Base17",
    width: 64.613,
    height: 64.613,
    transform: "translate(172.72 669.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-3",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#009060"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52050-3",
    "data-name": "Group 52050",
    transform: "translate(19.743 19.743)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_17-2",
    "data-name": 17,
    transform: "translate(12 19)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "17")))), /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5,
    transform: "translate(270.717 4652.501)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -172.72, -433)",
    filter: "url(#Base5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base5-2",
    "data-name": "Base5",
    width: 64.613,
    height: 64.613,
    transform: "translate(172.72 433)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-4",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#009060"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_5-2",
    "data-name": 5,
    transform: "translate(32.025 39.743)",
    fill: "#474243",
    fontSize: 22,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.311,
    y: 0
  }, "5"))), /*#__PURE__*/React.createElement("g", {
    id: "_13",
    "data-name": 13,
    transform: "translate(270.717 4810.444)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -172.72, -590.94)",
    filter: "url(#Base13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base13-2",
    "data-name": "Base13",
    width: 64.613,
    height: 64.613,
    transform: "translate(172.72 590.94)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-5",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#009060"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_13-2",
    "data-name": 13,
    transform: "translate(31.743 38.743)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "13"))), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(354.175 4573.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -256.18, -354.03)",
    filter: "url(#Base2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base2-2",
    "data-name": "Base2",
    width: 64.613,
    height: 64.613,
    transform: "translate(256.18 354.03)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-6",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#be3144"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2-2",
    "data-name": 2,
    transform: "translate(32.025 32.564)",
    fill: "#474243",
    fontSize: 22,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.311,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("g", {
    id: "Group_52051",
    "data-name": "Group 52051",
    transform: "translate(7.179 41.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1133",
    "data-name": "Ellipse 1133",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(0 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1134",
    "data-name": "Ellipse 1134",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(10.769 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1135",
    "data-name": "Ellipse 1135",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(21.538 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1136",
    "data-name": "Ellipse 1136",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(32.307 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1137",
    "data-name": "Ellipse 1137",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(43.075 0)",
    fill: "#be3144"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_10",
    "data-name": 10,
    transform: "translate(354.175 4731.473)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -256.18, -511.97)",
    filter: "url(#Base10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base10-2",
    "data-name": "Base10",
    width: 64.613,
    height: 64.613,
    transform: "translate(256.18 511.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-7",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#be3144"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_10-2",
    "data-name": 10,
    transform: "translate(31.743 31.564)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "10")), /*#__PURE__*/React.createElement("g", {
    id: "Group_52051-2",
    "data-name": "Group 52051",
    transform: "translate(7.179 41.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1133-2",
    "data-name": "Ellipse 1133",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(0 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1134-2",
    "data-name": "Ellipse 1134",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(10.769 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1135-2",
    "data-name": "Ellipse 1135",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(21.538 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1136-2",
    "data-name": "Ellipse 1136",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(32.307 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1137-2",
    "data-name": "Ellipse 1137",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(43.075 0)",
    fill: "#be3144"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_18",
    "data-name": 18,
    transform: "translate(354.175 4889.416)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -256.18, -669.92)",
    filter: "url(#Base18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base18-2",
    "data-name": "Base18",
    width: 64.613,
    height: 64.613,
    transform: "translate(256.18 669.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-8",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#be3144"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_18-2",
    "data-name": 18,
    transform: "translate(31.743 31.564)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "18")), /*#__PURE__*/React.createElement("g", {
    id: "Group_52051-3",
    "data-name": "Group 52051",
    transform: "translate(7.179 41.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1133-3",
    "data-name": "Ellipse 1133",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(0 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1134-3",
    "data-name": "Ellipse 1134",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(10.769 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1135-3",
    "data-name": "Ellipse 1135",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(21.538 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1136-3",
    "data-name": "Ellipse 1136",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(32.307 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1137-3",
    "data-name": "Ellipse 1137",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(43.075 0)",
    fill: "#be3144"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_6",
    "data-name": 6,
    transform: "translate(354.175 4652.501)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -256.18, -433)",
    filter: "url(#Base6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base6-2",
    "data-name": "Base6",
    width: 64.613,
    height: 64.613,
    transform: "translate(256.18 433)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-9",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#009060"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_6-2",
    "data-name": 6,
    transform: "translate(32.025 39.743)",
    fill: "#474243",
    fontSize: 22,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.311,
    y: 0
  }, "6"))), /*#__PURE__*/React.createElement("g", {
    id: "_14",
    "data-name": 14,
    transform: "translate(354.175 4810.444)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -256.18, -590.94)",
    filter: "url(#Base14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base14-2",
    "data-name": "Base14",
    width: 64.613,
    height: 64.613,
    transform: "translate(256.18 590.94)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-10",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#009060"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_14-2",
    "data-name": 14,
    transform: "translate(31.743 38.743)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "14"))), /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(436.736 4573.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -338.74, -354.03)",
    filter: "url(#Base3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base3-2",
    "data-name": "Base3",
    width: 64.613,
    height: 64.613,
    transform: "translate(338.74 354.03)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-11",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#be3144"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_3-2",
    "data-name": 3,
    transform: "translate(32.025 32.564)",
    fill: "#474243",
    fontSize: 22,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.311,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("g", {
    id: "Group_52052",
    "data-name": "Group 52052",
    transform: "translate(7.179 41.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1133-4",
    "data-name": "Ellipse 1133",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(0 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1134-4",
    "data-name": "Ellipse 1134",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(10.769 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1135-4",
    "data-name": "Ellipse 1135",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(21.538 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1136-4",
    "data-name": "Ellipse 1136",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(32.307 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1137-4",
    "data-name": "Ellipse 1137",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(43.075 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1138",
    "data-name": "Ellipse 1138",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(0 8.974)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1139",
    "data-name": "Ellipse 1139",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(10.769 8.974)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1140",
    "data-name": "Ellipse 1140",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(21.538 8.974)",
    fill: "#be3144"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_11",
    "data-name": 11,
    transform: "translate(436.736 4731.473)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -338.74, -511.97)",
    filter: "url(#Base11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base11-2",
    "data-name": "Base11",
    width: 64.613,
    height: 64.613,
    transform: "translate(338.74 511.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-12",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#be3144"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_11-2",
    "data-name": 11,
    transform: "translate(31.743 31.564)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "11")), /*#__PURE__*/React.createElement("g", {
    id: "Group_52052-2",
    "data-name": "Group 52052",
    transform: "translate(7.179 41.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1133-5",
    "data-name": "Ellipse 1133",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(0 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1134-5",
    "data-name": "Ellipse 1134",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(10.769 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1135-5",
    "data-name": "Ellipse 1135",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(21.538 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1136-5",
    "data-name": "Ellipse 1136",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(32.307 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1137-5",
    "data-name": "Ellipse 1137",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(43.075 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1138-2",
    "data-name": "Ellipse 1138",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(0 8.974)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1139-2",
    "data-name": "Ellipse 1139",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(10.769 8.974)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1140-2",
    "data-name": "Ellipse 1140",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(21.538 8.974)",
    fill: "#be3144"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_19",
    "data-name": 19,
    transform: "translate(436.736 4889.416)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -338.74, -669.92)",
    filter: "url(#Base19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base19-2",
    "data-name": "Base19",
    width: 64.613,
    height: 64.613,
    transform: "translate(338.74 669.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-13",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#be3144"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_19-2",
    "data-name": 19,
    transform: "translate(31.743 31.564)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "19")), /*#__PURE__*/React.createElement("g", {
    id: "Group_52052-3",
    "data-name": "Group 52052",
    transform: "translate(7.179 41.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1133-6",
    "data-name": "Ellipse 1133",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(0 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1134-6",
    "data-name": "Ellipse 1134",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(10.769 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1135-6",
    "data-name": "Ellipse 1135",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(21.538 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1136-6",
    "data-name": "Ellipse 1136",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(32.307 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1137-6",
    "data-name": "Ellipse 1137",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(43.075 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1138-3",
    "data-name": "Ellipse 1138",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(0 8.974)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1139-3",
    "data-name": "Ellipse 1139",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(10.769 8.974)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1140-3",
    "data-name": "Ellipse 1140",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(21.538 8.974)",
    fill: "#be3144"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_7",
    "data-name": 7,
    transform: "translate(436.736 4652.501)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -338.74, -433)",
    filter: "url(#Base7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base7-2",
    "data-name": "Base7",
    width: 64.613,
    height: 64.613,
    transform: "translate(338.74 433)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-14",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#009060"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_7-2",
    "data-name": 7,
    transform: "translate(32.025 39.743)",
    fill: "#474243",
    fontSize: 22,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.311,
    y: 0
  }, "7"))), /*#__PURE__*/React.createElement("g", {
    id: "_15",
    "data-name": 15,
    transform: "translate(436.736 4810.444)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -338.74, -590.94)",
    filter: "url(#Base15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base15-2",
    "data-name": "Base15",
    width: 64.613,
    height: 64.613,
    transform: "translate(338.74 590.94)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-15",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#009060"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_15-2",
    "data-name": 15,
    transform: "translate(31.743 38.743)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "15"))), /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(520.195 4573.53)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -422.19, -354.03)",
    filter: "url(#Base4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base4-2",
    "data-name": "Base4",
    width: 64.613,
    height: 64.613,
    transform: "translate(422.19 354.03)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-16",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#be3144"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_4-2",
    "data-name": 4,
    transform: "translate(32.025 32.564)",
    fill: "#474243",
    fontSize: 22,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.311,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("g", {
    id: "Group_52053",
    "data-name": "Group 52053",
    transform: "translate(12.564 41.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1133-7",
    "data-name": "Ellipse 1133",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(0 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1134-7",
    "data-name": "Ellipse 1134",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(10.769 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1135-7",
    "data-name": "Ellipse 1135",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(21.538 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1136-7",
    "data-name": "Ellipse 1136",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(32.307 0)",
    fill: "#be3144"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_12",
    "data-name": 12,
    transform: "translate(520.195 4731.473)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -422.19, -511.97)",
    filter: "url(#Base12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base12-2",
    "data-name": "Base12",
    width: 64.613,
    height: 64.613,
    transform: "translate(422.19 511.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-17",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#be3144"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_12-2",
    "data-name": 12,
    transform: "translate(31.743 31.564)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "12")), /*#__PURE__*/React.createElement("g", {
    id: "Group_52053-2",
    "data-name": "Group 52053",
    transform: "translate(12.564 41.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1133-8",
    "data-name": "Ellipse 1133",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(0 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1134-8",
    "data-name": "Ellipse 1134",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(10.769 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1135-8",
    "data-name": "Ellipse 1135",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(21.538 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1136-8",
    "data-name": "Ellipse 1136",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(32.307 0)",
    fill: "#be3144"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_20",
    "data-name": 20,
    transform: "translate(520.195 4889.416)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -422.19, -669.92)",
    filter: "url(#Base20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base20-2",
    "data-name": "Base20",
    width: 64.613,
    height: 64.613,
    transform: "translate(422.19 669.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-18",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#be3144"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_20-2",
    "data-name": 20,
    transform: "translate(31.743 31.564)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("g", {
    id: "Group_52053-3",
    "data-name": "Group 52053",
    transform: "translate(12.564 41.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1133-9",
    "data-name": "Ellipse 1133",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(0 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1134-9",
    "data-name": "Ellipse 1134",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(10.769 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1135-9",
    "data-name": "Ellipse 1135",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(21.538 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1136-9",
    "data-name": "Ellipse 1136",
    cx: 3.59,
    cy: 3.59,
    r: 3.59,
    transform: "translate(32.307 0)",
    fill: "#be3144"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_8",
    "data-name": 8,
    transform: "translate(520.195 4652.501)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -422.19, -433)",
    filter: "url(#Base8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base8-2",
    "data-name": "Base8",
    width: 64.613,
    height: 64.613,
    transform: "translate(422.19 433)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-19",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#009060"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_8-2",
    "data-name": 8,
    transform: "translate(32.025 39.743)",
    fill: "#474243",
    fontSize: 22,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.311,
    y: 0
  }, "8"))), /*#__PURE__*/React.createElement("g", {
    id: "_16",
    "data-name": 16,
    transform: "translate(520.195 4810.444)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -422.19, -590.94)",
    filter: "url(#Base16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base16-2",
    "data-name": "Base16",
    width: 64.613,
    height: 64.613,
    transform: "translate(422.19 590.94)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-20",
    "data-name": "Status_table",
    width: 3.59,
    height: 64.613,
    transform: "translate(0 64.613) rotate(-90)",
    fill: "#009060"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_16-2",
    "data-name": 16,
    transform: "translate(31.743 38.743)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "16"))), /*#__PURE__*/React.createElement("g", {
    id: "_21",
    "data-name": 21,
    transform: "translate(270.717 4968.387)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -172.72, -748.89)",
    filter: "url(#Base21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base21-2",
    "data-name": "Base21",
    width: 64.613,
    height: 49.613,
    transform: "translate(172.72 748.89)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_21-2",
    "data-name": 21,
    transform: "translate(31.743 38.743)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "21"))), /*#__PURE__*/React.createElement("g", {
    id: "_22",
    "data-name": 22,
    transform: "translate(354.176 4968.387)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -256.18, -748.89)",
    filter: "url(#Base22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base22-2",
    "data-name": "Base22",
    width: 64.613,
    height: 49.613,
    transform: "translate(256.18 748.89)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_22-2",
    "data-name": 22,
    transform: "translate(31.743 38.743)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "22"))), /*#__PURE__*/React.createElement("g", {
    id: "_23",
    "data-name": 23,
    transform: "translate(436.736 4968.387)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -338.74, -748.89)",
    filter: "url(#Base23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base23-2",
    "data-name": "Base23",
    width: 64.613,
    height: 49.613,
    transform: "translate(338.74 748.89)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_23-2",
    "data-name": 23,
    transform: "translate(31.743 38.743)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "23"))), /*#__PURE__*/React.createElement("g", {
    id: "_24",
    "data-name": 24,
    transform: "translate(520.195 4968.387)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -422.2, -748.89)",
    filter: "url(#Base24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base24-2",
    "data-name": "Base24",
    width: 64.613,
    height: 49.613,
    transform: "translate(422.2 748.89)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_24-2",
    "data-name": 24,
    transform: "translate(31.743 38.743)",
    fill: "#474243",
    fontSize: 21,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.048,
    y: 0
  }, "24"))), /*#__PURE__*/React.createElement("g", {
    id: "_4_big",
    "data-name": "4_big",
    transform: "translate(454.685 4508.02)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -356.68, -288.52)",
    filter: "url(#Base)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-3",
    "data-name": "Base",
    width: 195.634,
    height: 195.634,
    transform: "translate(356.68 288.52)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Status_table-21",
    "data-name": "Status_table",
    width: 10.869,
    height: 195.634,
    transform: "translate(0 195.634) rotate(-90)",
    fill: "#be3144"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_4-3",
    "data-name": 4,
    transform: "translate(96.797 97.04)",
    fill: "#474243",
    fontSize: 64,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18.359,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("g", {
    id: "Group_52053-4",
    "data-name": "Group 52053",
    transform: "translate(38.04 124.989)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1133-10",
    "data-name": "Ellipse 1133",
    cx: 10.869,
    cy: 10.869,
    r: 10.869,
    transform: "translate(0 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1134-10",
    "data-name": "Ellipse 1134",
    cx: 10.869,
    cy: 10.869,
    r: 10.869,
    transform: "translate(32.605 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1135-10",
    "data-name": "Ellipse 1135",
    cx: 10.869,
    cy: 10.869,
    r: 10.869,
    transform: "translate(65.213 0)",
    fill: "#3e813f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1136-10",
    "data-name": "Ellipse 1136",
    cx: 10.869,
    cy: 10.869,
    r: 10.869,
    transform: "translate(97.818 0)",
    fill: "#be3144"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescQuadroFnbSpaces);
export default __webpack_public_path__ + "static/media/desc-quadro-fnb-spaces.33032c5c6d17c0b539c19cb02b7132a3.svg";
export { ForwardRef as ReactComponent };